// src/main.js
import Vue from 'vue'

// 引入 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入 App
import App from './App'

// 引入 Bootstrap CSS
import './assets/css/bootstrap.min.css'

// 引入路由器
import router from './router'
import store from './store'

// 二维码生成器
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

// 关闭 Vue 生产提示
Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  store, // 必须注入 store
  render: h => h(App)
}).$mount('#app')